import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { DeltaSink } from 'app/model/pipeline/copysink/delta.sink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DeltaSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class DeltaSinkAdapter extends CopySinkAdapter<DeltaSink, Model.DeltaSink> {
    protected override async _toResource(model: DeltaSink): Promise<Model.DeltaSink> {
        const result: Model.DeltaSink = {
            type: 'DeltaSink'
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(resource: Model.DeltaSink, owner: Activity): Promise<DeltaSink> {
        const result = Owned.create<DeltaSink>(Metamodel.modelFor(DeltaSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);

        return result;
    }
}
